import React from 'react';
import ScenarioListItem from '../ScenarioListItem.tsx';
import type { ScenarioDto } from '@/api-gen/api.schemas';

type SceneGroupContainerListItemProps = {
  scene: ScenarioDto;
  sceneId: number;
  classes: {
    selected: string;
    withB: string;
    withTBP: string;
    sharedScenario: string;
    subMenuWidth: string;
    white: string;
    nested: string;
    subGroupSubMenuWidth: string;
  };
  handleSelectScenario: () => void;
  handleRightClick: (event: React.MouseEvent<HTMLElement>, scene: ScenarioDto) => void;
  isSubGroupItem?: boolean;
  disableActions?: boolean;
};

const SceneGroupContainerListItem: React.FC<SceneGroupContainerListItemProps> = React.memo(
  ({ scene, sceneId, classes, handleSelectScenario, handleRightClick, isSubGroupItem, disableActions }) => (
    <ScenarioListItem
      scene={scene}
      classes={classes}
      handleRightClick={handleRightClick}
      handleSelectScenario={handleSelectScenario}
      isSelected={scene.id === sceneId}
      isSubGroupItem={isSubGroupItem}
      disableActions={disableActions}
    />
  )
);

SceneGroupContainerListItem.displayName = 'SceneGroupContainerListItem';

export default SceneGroupContainerListItem;
